import { PartialDeep } from 'type-fest';
import { FormContext } from 'vee-validate';
import { z } from 'zod';
/* eslint-disable import/prefer-default-export */
export const getSchema = () => {
  const schema = z.object({
    emails: z.array(z.string().email()).nonempty(),
    suplier: z.string().nonempty(),
  });

  return schema;
};

export type FormSchema = z.infer<ReturnType<typeof getSchema>>
export type Form = FormContext<PartialDeep<FormSchema>>
export type Field = keyof(FormSchema)
